import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const waterIntakeCalculatorTool: Tool = {
  id: "water-intake-calculator",
  name: () => m.water_tool_name(),
  description: () => m.water_tool_description(),
  icon: "💧",
  basePath: "/water-intake-calculator",
  status: "stable",
  tags: ["health", "fitness", "calculator", "water-intake-calculator"],
};
